<template>
  <div class="headliner-spinner-container" v-if="!advancedVideo.url">
    <div class="headliner-spinner-container__main-message">
      <h4 style="color: white;">Loading headliner...</h4>
    </div>
    <div class="divider"></div>
    <div>
      <loading-spinner />
    </div>
  </div>
  <div v-else class="iframe-wrapper">
    <iframe
      style="border: none;"
      :src="advancedVideo.url"
      allow="autoplay">
    </iframe>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import LoadingSpinner from '../components/LoadingSpinner';

export default {
  computed: {
    ...mapState(['advancedVideo']),
    ...mapGetters('draftEpisodes', ['editingEpisode', 'currentDraftEpisode']),

    workingEpisodeId () {
      return parseInt(this.$route.query.editingEpisode ? this.$route.query.editingEpisode : this.$route.params.episodeId);
    },

  },

  methods: {
    ...mapActions(['getAdvancedVideoEditUrl']),

    handleError () {
      const { showId } = this.$route.params;
      if (this.advancedVideo.playlist_id === this.workingEpisodeId) {
        this.$store.commit('SET_MESSAGE', {
          name: 'Video Error',
          details: `We were unable to initialize the video editor for episode ID ${this.workingEpisodeId}. Please try again later.`,
          type: 'error'
        });
        this.$store.commit('CLEAR_ADVANCED_VIDEO_DATA');
        this.$router.push({ name: 'show-detail', params: { showId } });
      }
    }
  },

  mounted() {
    if (this.advancedVideo.isFailed) {
      this.handleError();
    }
  },

  watch: {
    'advancedVideo.isCreated' () {
      const { showId } = this.$route.params;
      if (this.advancedVideo.playlist_id === this.workingEpisodeId && this.advancedVideo.isCreated) {
        this.$store.commit('CLEAR_ADVANCED_VIDEO_DATA');
        this.$router.push({ name: 'show-detail', params: { showId } });
      }
    },

    'advancedVideo.isFailed' (isFailed) {
      if (isFailed) {
        this.handleError();
      }
    }
  },

  components: {
    LoadingSpinner,
  }
};
</script>

<style lang="scss" scoped>

.headliner-spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__main-message {
    padding-top: 7%;
  }

  .divider {
    width: 100%;
    height: 15px;
    background: transparent;
  }

}

.iframe-wrapper {
  height: 800px;

  iframe {
    height: 100%;
    width: 100%;
  }
}

</style>
